<div class="overflow-hidden flex-grow-1" [wdxIsLoading]="loading">
    @if (gridOptions) {
        <ag-grid-angular
            [gridOptions]="gridOptions"
            [localeText]="localeText"
            [autoGroupColumnDef]="autoGroupColumnDef()"
            [columnDefs]="columnDefs"
            [defaultColDef]="defaultColDef"
            wdxUtilsAgGridTheme
            class="ag-theme-quartz w-100 h-100"
            (gridReady)="onGridReady($event)"
            (sortChanged)="onSortChanged($event)"
            (rowClicked)="onRowClicked($event)"
            (selectionChanged)="onGridSelectionChanged($event)"
        ></ag-grid-angular>
    }
</div>
@if (bulkSelect && selectedRows.length) {
    <wdx-multi-select-banner
        data-cy="grid-multi-select-banner"
        [selectedCount]="selectedRows.length"
        [totalItems]="totalRecords"
        (wdxOnClose)="clearSelection()"
    >
        <ng-content select="[wdxBulkActions]"></ng-content>
    </wdx-multi-select-banner>
}
